import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import * as React from "react";
import { useTranslation } from "react-i18next";
import { applicationInfoType } from "types/app";
import DeleteDialogBody from "./DeleteDialogBody";
import EditDialogBody from "./EditDialogBody";

interface ISimpleDialogProps {
	openModal: boolean;
	selectedMenuType: number;
	handleModalClose: () => void;
	ApplicationInfo: applicationInfoType[];
	ApplicationItem: applicationInfoType;
	setApplicationInfo: (value: applicationInfoType[]) => void;
}

const SimpleDialog: React.FC<ISimpleDialogProps> = ({
	ApplicationInfo,
	handleModalClose,
	selectedMenuType,
	openModal,
	ApplicationItem,
	setApplicationInfo,
}) => {
	const { t } = useTranslation();
	return (
		<Dialog onClose={handleModalClose} open={openModal} fullWidth={true}>
			{selectedMenuType === 1 ? (
				<>
					<DialogTitle sx={{ fontSize: "2rem" }}>
						{t("application_delete.title")}
					</DialogTitle>
					<DeleteDialogBody
						ApplicationInfo={ApplicationInfo}
						handleModalClose={handleModalClose}
						ApplicationItem={ApplicationItem}
						setApplicationInfo={setApplicationInfo}
					/>
				</>
			) : (
				<>
					<DialogTitle sx={{ fontSize: "2rem" }}>
						{t("application_change_name")}
					</DialogTitle>
					<EditDialogBody
						ApplicationInfo={ApplicationInfo}
						handleModalClose={handleModalClose}
						ApplicationItem={ApplicationItem}
						setApplicationInfo={setApplicationInfo}
					/>
				</>
			)}
		</Dialog>
	);
};
export default SimpleDialog;
